import { useOutletContext } from "react-router-dom";
import PaymentFailed from "../../shared/PaymentFailed";

const EapPaymentFailed = () => {
  const { customer, payment, contactId } = useOutletContext();

  return (<PaymentFailed
    merchant={customer.merchant}
    reference={payment.reference}
    retryUrl={`/embeddedaccountpayment?cu=${contactId}`} />);
};

export default EapPaymentFailed;
